import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import BubbleContent from '../content/bubble_content';
import ConversationItem from 'models/conversation_item';
import FbMessageAttachmentContainer from './attachments/fb_message_attachment_container';
import FbMessageAttachmentsContainer from './attachments/fb_message_attachments';
import FbStickerContainer from './attachments/fb_sticker_container';
import InlineAnnotatedContentContainer from 'components/lib/inline_annotated_content_container';
import ItemContent from '../item_content';
import ItemMetadata from '../item_metadata';
import Link from 'components/common/link';

export default function FacebookIncomingItem({ className, isFirstInStack, isLastInStack, isStacked, item }) {
  return (
    <ItemContent
      isFirstInStack={isFirstInStack}
      isLastInStack={isLastInStack}
      isStacked={isStacked}
      item={item}
      showIcon={!isStacked}
    >
      <ItemMetadata item={item} showMetadata={!isStacked} />
      <FacebookIncomingContent className={className} item={item} />
    </ItemContent>
  );
}

FacebookIncomingItem.propTypes = {
  className: PropTypes.string,
  isFirstInStack: PropTypes.bool,
  isLastInStack: PropTypes.bool,
  isStacked: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export function FacebookIncomingContent({ className, item }) {
  const text = _.get(item, 'content.message.text');
  const attachments = _.get(item, 'content.message.attachments', []);
  const sticker = attachments.length === 1 && attachments[0].isSticker() && attachments[0];
  const links = _.get(item, 'content.message.links', []);

  return (
    <BubbleContent className={classnames('facebookIncomingItem-content', className)} item={item}>
      {renderLinks()}
      {renderText()}
      {renderAttachments()}
      {renderSticker()}
    </BubbleContent>
  );

  function renderText() {
    if (!text) {
      return null;
    }
    return (
      <InlineAnnotatedContentContainer
        hasRedactedPaymentCard={item.content.hasRedactedPaymentCardNumber}
        id={item.id}
        text={text}
      />
    );
  }

  function renderLinks() {
    if (!links.length) {
      return null;
    }

    let externalLinks = [];
    links.forEach((link, idx) => {
      let title = link.title || link.url;
      externalLinks.push(
        <Link key={`${link.url}-${idx}`} href={link.url} onClick={() => window.open(link.url, '_blank')}>
          {title}
        </Link>
      );
    });

    return externalLinks;
  }

  function renderAttachments() {
    if (!attachments.length || sticker) {
      return null;
    }
    return <FbMessageAttachmentsContainer attachments={attachments} conversationItemId={item.id} />;
  }

  function renderSticker() {
    if (!sticker) {
      return null;
    }

    if (!sticker.isAvailable()) {
      return <FbMessageAttachmentContainer attachment={sticker} />;
    }

    return <FbStickerContainer attachment={sticker} />;
  }
}

FacebookIncomingContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/facebook/facebook_incoming_item.jsx